import {SCREEN_SHARING_VIDEO_TRACK} from 'constants/session';
import {MediaDevicesConstraints} from 'types';
import {logger} from 'utils';

import {Participant} from './Participant';
import {PeerConnectionId} from './constants';

export class LocalParticipant extends Participant {
    getAudioTracks(peerId: PeerConnectionId) {
        return this.getPeerConnection(peerId)?.rtcPeer?.getLocalStream()?.getAudioTracks?.() || [];
    }

    getVideoTracks(peerId: PeerConnectionId) {
        return this.getPeerConnection(peerId)?.rtcPeer?.getLocalStream()?.getVideoTracks?.()
            .filter((track) => track.label !== SCREEN_SHARING_VIDEO_TRACK) || [];
    }

    toggleAudioTracks(peerId: PeerConnectionId, enable: boolean) {
        if (enable) {
            this.enableAudioTracks(peerId);
        } else {
            this.disableAudioTracks(peerId);
        }
    }

    toggleVideoTracks(peerId: PeerConnectionId, enable: boolean) {
        if (enable) {
            this.enableVideoTracks(peerId);
        } else {
            this.disableVideoTracks(peerId);
        }
    }

    enableAudioTracks(peerId: PeerConnectionId) {
        this.getAudioTracks(peerId).forEach((track) => track.enabled = true);
    }

    disableAudioTracks(peerId: PeerConnectionId) {
        this.getAudioTracks(peerId).forEach((track) => track.enabled = false);
    }

    enableVideoTracks(peerId: PeerConnectionId) {
        this.getVideoTracks(peerId).forEach((track) => track.enabled = true);
    }

    disableVideoTracks(peerId: PeerConnectionId) {
        this.getVideoTracks(peerId).forEach((track) => track.enabled = false);
    }

    restartInputDevices = (peerId: PeerConnectionId, constraints: MediaDevicesConstraints) => {
        const peer = this.getPeerConnection(peerId);
        const senders = peer.rtcPeer.peerConnection.getSenders();
        peer.stopLocalTracks();
        navigator.mediaDevices.getUserMedia({
            audio: constraints?.audioinput,
            ...(constraints?.videoinput && {video: constraints?.videoinput})
        }).then((stream) => {
            stream.getTracks().forEach((track) => {
                const sender = senders.find((s) => s.track.kind === track.kind);
                sender.replaceTrack(track);
            });
            peer.attachStream(stream);
        }).catch(logger.error);
    };

    restartOutputDevice = (peerId: PeerConnectionId, deviceId: string) => {
        const peer = this.getPeerConnection(peerId);
        peer.setMainRemoteParticipantAudioOutput(deviceId);
    };
}
